import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export default function LoadingScreen() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        width: 1,
        height: 1,
        minHeight: "70vh", // Use minHeight instead of fixed 100vh to avoid overflow in layouts
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress color="primary" sx={{ mb: 2 }} />
        <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
          Loading...
        </Typography>
      </Box>
    </Box>
  );
}
